import { Flex, Heading, Text } from "@chakra-ui/react";
import React from "react";
import { CopyToClipboard } from "src/components/Text/CopyToClipboard";
import { formatUuid } from "src/services/id";

interface Props {
  id?: string;
  title: string;
  titleIcon?: React.ReactNode;
  upperTitle?: string;
  actionButton?: React.ReactNode;
  actionBar?: React.ReactNode;
  badge?: React.ReactNode;
  subtitle?: string;
}
export const AdminHeading: React.FC<Props> = ({
  id,
  title,
  subtitle,
  titleIcon,
  upperTitle,
  actionButton,
  actionBar,
  badge,
}) => {
  return (
    <Flex direction="column" gap={2} w="100%">
      {upperTitle && (
        <Text fontSize="md" fontWeight="500" color="gray.500">
          {upperTitle}
        </Text>
      )}

      <Flex justifyContent="space-between">
        <Flex direction="column">
          <Flex gap={2}>
            <Heading as="h1" variant="admin" gap={2} display="flex">
              {title}
              {titleIcon}
            </Heading>
            {badge}
          </Flex>
          {subtitle && (
            <Text fontSize="lg" textColor="gray.600" fontWeight="400">
              {subtitle}
            </Text>
          )}
          {id && (
            <Text fontSize="lg" textColor="gray.500" fontWeight="400">
              ID: <CopyToClipboard text={formatUuid(id)} />
            </Text>
          )}
        </Flex>
        {actionButton}
      </Flex>

      {actionBar}
    </Flex>
  );
};
